<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <contentheading
        :button="$t('producers.add')"
        :title="$t('producers.title')"
        url="producer_add"/>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <datatablebuttons/>
                <search @make_search="make_search"/>
                <table class="table table-striped dataTable my-4 w-100" id="producers">
                  <thead>
                    <tr>
                      <th>
                        <div class="checkbox c-checkbox">
                          <label class="mb-0 p">
                            <input class="select-box" type="checkbox" v-model="selectAll">
                            <span class="fa fa-check"></span>
                          </label>
                        </div>
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'name',
                          'sorting_desc': ordering === '-name'
                        }"
                        @click="order('name')">{{ $t('producers.producer') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'is_active',
                          'sorting_desc': ordering === '-is_active'
                        }"
                        @click="order('is_active')">{{ $t('producers.state') }}
                      </th>
                      <th class="wd-xs"></th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in rows" :key="row.id" class="gradeX">
                    <td>
                      <div class="checkbox c-checkbox">
                        <label class="mb-0">
                          <input :value="row.id" class="select-box" type="checkbox" v-model="selected">
                          <span class="fa fa-check"></span>
                        </label>
                      </div>
                    </td>
                    <td>{{ row.name }}</td>
                    <td>{{ row.is_active ? 'Active': 'Disabled' }}</td>
                    <td>
                      <div class="btn-group">
                        <router-link
                          :to="{name: 'producer_edit', params: {id: row.id}}"
                          title="$t('producers.button-edit')"
                          class="far fa-edit btn btn-link link-unstyled px-1 py-2 text-info">
                        </router-link>
                        <button
                          class="btn btn-link pl-1 pt-1 text-info"
                          :title="$t('producers.button-delete')"
                          @click="remove_producer(row.id, index)">
                          <i class="far fa-trash-alt"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <pagination
                   :page="page"
                   :pages="pages"
                   :count="count"
                   :from="(page - 1) * page_size + 1"
                   :to="(page - 1) * page_size + rows.length"
                   @paginate="paginate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Contentheading from '@/components/Contentheading.vue'
import Datatablebuttons from '@/components/Datatablebuttons.vue'
import Pagination from '@/components/Pagination.vue'
import message from '@/message'
import Search from '@/components/Search.vue'

const getData = (route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || 'name'
  const page = parseInt(route.query.page) || 1

  let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
      || {}
  let page_size = route.query.page_size
      || stored_page_size[route.name]
      || process.env.DEFAULT_PAGE_SIZE

  api.get('/producers/', {
    params: {
      search: search,
      ordering: ordering,
      page: page,
      page_size: page_size
    }
  })
    .then(resp => {
      let rowsData = []
      let rows = resp.data.results

      rows.forEach(row => {
        rowsData.push({
          0: row.id,
          1: row.name,
          2: row.is_active ? 'Active' : 'Disabled'
        })
      })

      next({
        rows: rows,
        rowsData: rowsData,
        search: search,
        ordering: ordering,
        pages: resp.data.pages,
        count: resp.data.count,
        page: page,
        page_size: page_size
      })
    })
}

export default {
  components: {
    contentheading: Contentheading,
    datatablebuttons: Datatablebuttons,
    pagination: Pagination,
    search: Search
  },
  data () {
    return {
      rows: [],
      rowsData: [],
      search: null,
      ordering: null,
      pages: null,
      count: null,
      page: null,
      page_size: null,
      selected: [],
      columns: [
        'Tootja',
        'Staatus'
      ]
    }
  },
  mounted () {
    this.$parent.menu = 'setup'
    this.$parent.submenu = 'producers'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    remove_producer (id, index) {
      this.$swal({
        type: 'warning',
        title: this.$i18n.t('producers.are-you-sure'),
        text: this.$i18n.t('producers.are-you-sure-text-cancel'),
        showCancelButton: true
      })
        .then((choice) => {
          if (choice.value) {
            api.patch(`/producers/${id}/`, {is_deleted: true, is_active: false})
              .then(() => {
                message.success(this.$i18n.t('producers.deleted'))
                this.$delete(this.rows, index)
              })
              .catch(() => {
                message.error(this.$i18n.t('producers.forbidden'))
              })
          }
        })
    },
    order (o) {
      this.$parent.order(o, this.search, this.ordering)
    },
    paginate (p) {
      this.$parent.paginate(p, this.search, this.ordering)
    },
    make_search () {
      this.$parent.make_search(this.search, this.ordering)
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    },
    selectAll: {
      get: function () {
        return this.rows ? this.selected.length === this.rows.length : false
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.rows.forEach(function (p) {
            selected.push(p.id)
          })
        }
        this.selected = selected
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Producers.vue